import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { NavigationService } from '../services/navigation.service';
import { ModalService } from '../../modal/modal.service';
import { ErrorPopupComponent } from '../../modal/components/error-popup/error-popup.component';
import { shouldShowPalletLayerLoadTooLargeMessage } from '../../shared/helpers/pallet-layer-calculate.helper';

@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptor {
  private readonly DEFAULT_TIMEOUT = 60000;

  constructor(
    private navigationService: NavigationService,
    private router: Router,
    private modalService: ModalService
  ) {}

public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  // Check if the custom header is present
  if (request.headers.has('X-Skip-Interceptor')) {
    // Clone the request and remove the custom header
    const newRequest = request.clone({
      headers: request.headers.delete('X-Skip-Interceptor')
    });
    return next.handle(newRequest);
  }

  let requestTimeout = this.DEFAULT_TIMEOUT;
  if (request.headers.has('X-Request-Timeout')) {
    const timeoutValue = parseInt(request.headers.get('X-Request-Timeout'), 10);
    if (!isNaN(timeoutValue) && timeoutValue > 0) {
      requestTimeout = timeoutValue;
    }
    request = request.clone({
      headers: request.headers.delete('X-Request-Timeout')
    });
  }

  return next.handle(request).pipe(
    timeout(requestTimeout),
    catchError((error: HttpErrorResponse | TimeoutError) => {
      if (error instanceof TimeoutError) {
        const timeoutError = new HttpErrorResponse({
          error: { message: 'Request timeout - żądanie trwało zbyt długo' },
          status: 408,
          statusText: 'Request Timeout',
          url: request.url
        });
        return throwError(timeoutError);
      }

      if (shouldShowPalletLayerLoadTooLargeMessage(error, request.url)) {
        this.modalService
          .open(ErrorPopupComponent, {
            headerKey: 'warning',
            messageKey: 'pallet_layer_load_too_large_for_pallet',
            hideHomepageLink: true,
          })
          .subscribe();
        return throwError(error);
      }

      if (error.status === 500) {
        this.modalService.open(ErrorPopupComponent, null).subscribe();
        return throwError(error);
      } else if (error.status === 401) {
        if (localStorage.token && this.router.url.includes('session')) {
          localStorage.removeItem('token');
        } else if (localStorage.token) {
          localStorage.removeItem('token');
          this.navigationService.navigateToLogin();
        }
        return throwError(error);
      } else {
        return throwError(error);
      }
    }),
  );
}
}
